import { TreeItem, TreeView } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { AsuntosContext } from '../../pages/asuntos/AsuntosPage'
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import { AddCircleOutlineRounded, Check } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ObtenerArbolActivos } from '../../helpers/ActivosHelper';

export const ModalInstalacionComponent = () => {
    const {instalacionSeleccionada, setInstalacionSeleccionada,modalSeleccionInstalacion, setModalSeleccionInstalacion,modalAgregaAsunto, setModalAgregaAsunto } = useContext(AsuntosContext)
    const [activos, setActivos] = useState([]);

    const obtenerActivos =() => {
        ObtenerArbolActivos().then(datos=>setActivos(datos));
      }  
      
      useEffect(() => {
        obtenerActivos();
    }, [])

    const handleClose = () => {
          setModalSeleccionInstalacion(false);
      }

      const iconoNodo = () => {
        return (
        <EmojiTransportationIcon style={{fontSize:15}} />
        )
    }

      const renderTree = (nodo) =>  (
        <TreeItem  
          onClick={() => setInstalacionSeleccionada(nodo)}
          key={nodo.key} nodeId={nodo.key} label={
            <div
                style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}
            >
              <div
                style={{
                  display:'flex',
                  flexDirection:'row'
                }}
              >
                  {iconoNodo()}
                  <Typography
                      style={{fontSize:13, marginLeft:5}}
                  >
                  {nodo.title}

                  </Typography>
                </div>
                <div>
                  <IconButton
                    onClick={(e) => {e.stopPropagation(); setInstalacionSeleccionada(nodo); setModalSeleccionInstalacion(false) }}
                  >
                    <Check style={{fontSize:15, color:'green'}} />
                  </IconButton>
                  <IconButton
                    //onClick={(e) => {console.log('click en eliminar'); eliminarActivo(nodo.key); e.stopPropagation()}}
                  >
                  </IconButton>
                </div>
            </div>
        }>
          {Array.isArray(nodo.children)
?  nodo?.children?.map(node => renderTree(node))
: null}
        </TreeItem>
      )      

    return (
        <div
          style={{
              minWidth:600, minHeight:800
          }}
      >
       <Dialog open={modalSeleccionInstalacion} onClose={handleClose}>
          <DialogTitle>
            <Typography>
                Instalaciôn
            </Typography>
   
          </DialogTitle>
          <DialogContent
              style={{minWidth:600}}
          >
        <div
          style={{
            display:'flex',
            flexDirection:'column',
            flex:40,
            overflowY:'auto',
            maxHeight:'80vh'
      //      height:'100%'
          }}
        >
            {
                activos?.length>0 ? (
          <TreeView
            aria-label="rich object"
            defaultCollapseIcon={<ExpandMoreIcon />}
            //defaultExpanded={['1']}
            //defaultExpanded={true}
            defaultExpandIcon={<ChevronRightIcon />}
            
            sx={{ height: '100%', flexGrow: 1, maxWidth: 400, overflowY: 'auto', backgroundColor:'white', padding:1, borderRadius:10, paddingTop:3 }}
            >
            {
              activos?.map(nodo => (
                renderTree(nodo)
                
                ))
              }
          </TreeView>
                ):<div>Cargando...</div>
        }
        </div>            
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }